export const MapTypes = {
    OPERATE: 'OPERATE',
    FOOTPRINT: 'FOOTPRINT',
};
